import { FC } from 'react';
import { PublicPacket as PublicPacketFillingExperience } from '../../actual';
import { FillingExperienceProps } from '../../filling-experience.type';

export const PublicPacket: FC<FillingExperienceProps> = (props) => {
  return <PublicPacketFillingExperience {...props} isPreviewMode={true} />;
};
